import {
    DEALERADDUPDATETHANALIST_SUCCESS,
    DEALERADDUPDATETHANALIST_FAILED,
    RESET_DEALERADDUPDATETHANALIST,
    LOADING_DEALERADDUPDATETHANALIST,
    NETWORK_ERROR_DEALERADDUPDATETHANALIST
} from "../types/index"

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDUPDATETHANALIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDUPDATETHANALIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDUPDATETHANALIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDUPDATETHANALIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDUPDATETHANALIST:
            return (state = initialState);
        default:
            return state;
    }
};